import { render, staticRenderFns } from "./IndividualDiscovery.vue?vue&type=template&id=560322b8&"
import script from "./IndividualDiscovery.vue?vue&type=script&lang=js&"
export * from "./IndividualDiscovery.vue?vue&type=script&lang=js&"
import style0 from "./IndividualDiscovery.vue?vue&type=style&index=0&id=560322b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports